import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";

import { userInfoCacheKey } from "./constants";
import type {
  PutUserInfoUpdateSubscriptionStatusParams,
  PutUserInfoUpdateSubscriptionStatusResponse,
} from "./types";

export const putUserInfoUpdateSubscriptionStatus = reactQueryMutationAdapter(
  [userInfoCacheKey],
  ({
    userId,
    ...body
  }: PutUserInfoUpdateSubscriptionStatusParams): Promise<PutUserInfoUpdateSubscriptionStatusResponse> => {
    return fetch(`/apps/user_info/${userId}/update_subscription_status`, "PUT", body);
  }
);
